import { Button } from "flowbite-react";
import { ClipboardList, X } from "lucide-react";
import { toast } from "sonner";
import type { MandatoryCustomForm } from "@/shared/types/askedAttributes.types";
import { H5 } from "@/shared/ui/typographies/h5";
import { P } from "@/shared/ui/typographies/paragraph";

type MandatoryCustomFormToastProps = {
  toastId: string | number
  form: MandatoryCustomForm
  onDismiss?: () => void
  onNavigateToForm: () => void
};

// Réponses envoyées mais pas encore validées : le salarié ne peut plus rien
// faire, il attend le CSE.
const isAwaitingValidation = (form: MandatoryCustomForm) =>
  form.mandatory_on_login === "until_validated" && form.submission_status === "submitted";

const MandatoryCustomFormToast = ({
  toastId,
  form,
  onDismiss,
  onNavigateToForm,
}: MandatoryCustomFormToastProps) => {
  const awaitingValidation = isAwaitingValidation(form);

  const handleNavigateToForm = () => {
    toast.dismiss(toastId);
    onNavigateToForm();
    onDismiss?.();
  };

  const handleDismiss = () => {
    toast.dismiss(toastId);
    onDismiss?.();
  };

  return (
    <div className="w-80 max-w-sm rounded-lg shadow-lg bg-white dark:bg-gray-800 p-4 relative">
      <button
        onClick={handleDismiss}
        className="absolute top-5 right-5 text-amber-700 dark:text-amber-400 hover:text-amber-900 dark:hover:text-amber-300 transition-colors z-10"
        aria-label="Fermer"
      >
        <X size={20} />
      </button>

      <div className="bg-amber-100 dark:bg-amber-900/30 rounded-lg p-6 flex items-center justify-center mb-4">
        <ClipboardList
          size={32}
          className="text-amber-600 dark:text-amber-500"
        />
      </div>

      <div className="space-y-3">
        <H5 className="text-gray-900 dark:text-white">
          Formulaire obligatoire
        </H5>

        <P size="sm" color="base">
          {awaitingValidation
            ? `Vos réponses au formulaire « ${form.title} » sont en attente de traitement par votre CSE.`
            : `Votre CSE vous demande de compléter le formulaire « ${form.title} » avant d'accéder à votre espace.`}
        </P>

        <div className="pt-2">
          <Button color="primary" fullSized onClick={handleNavigateToForm}>
            {awaitingValidation ? "Voir le formulaire" : "Compléter le formulaire"}
          </Button>
        </div>
      </div>
    </div>
  );
};

MandatoryCustomFormToast.displayName = "MandatoryCustomFormToast";

export { MandatoryCustomFormToast };
export type { MandatoryCustomFormToastProps };
